export default __webpack_public_path__ + "static/media/GreenFlagLogoNoOutlineDesktop.bdd5fa44.svg";